import { render, staticRenderFns } from "./ViqPage.vue?vue&type=template&id=d9a3aa5e&scoped=true"
import script from "./ViqPage.vue?vue&type=script&lang=js"
export * from "./ViqPage.vue?vue&type=script&lang=js"
import style0 from "./ViqPage.vue?vue&type=style&index=0&id=d9a3aa5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a3aa5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a3aa5e')) {
      api.createRecord('d9a3aa5e', component.options)
    } else {
      api.reload('d9a3aa5e', component.options)
    }
    module.hot.accept("./ViqPage.vue?vue&type=template&id=d9a3aa5e&scoped=true", function () {
      api.rerender('d9a3aa5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqPage.vue"
export default component.exports